<template>
  <Page>

    <!-- <div class="popup-code" :class="{show:codeIsShow}" @click="close">
      <div class="close" @click="close"><i class="el-icon-close"></i></div>
      <div class="code">
        <img :src="bmcodesrc" alt="">
      </div>
    </div> -->

    <div class="popup-code" :class="{show:codeIsShow}" @click="close">
      <div class="close" @click="close"><i class="el-icon-close"></i></div>
      <div class="code">
        <img src="https://reg.uniceramics.com.cn/assets/yanqi2022-en.jpg" alt="">
      </div>
    </div>


    <div class="slidebox" :style="{'background':'url('+banner[0].picture+') no-repeat','background-size':'100% 100%'}">
       <keep-alive include="slide">
        <Slide></Slide>
       </keep-alive>
        <div class="wrap">
          <div class="center">
            <h2>Uniceramics Expo 2024</h2>
            <h4>Products + Technology Expo At the same time</h4>
            <h4>18th - 22nd April 2024</h4>
            <!-- <h4>2022/11/16-20</h4> -->
            <!-- <div class="btn-box mt40">
              <a href="https://reg.uniceramics.com.cn/en?tp=2" target="_bland"><Btn color="red" title="Register Now"></Btn></a>
              <a href="https://reg.uniceramics.com.cn/expomap/#/" target="_bland"><Btn color="red" title="Exhibition Assistant"></Btn></a>
            </div> -->
            <div class="btn-box">
              <a href="https://regen2024.uniceramics.com.cn/" target="_bland"><Btn color="red" title="Registration"></Btn></a>
            </div>
           <!--  <div class="contact-box">
              <div>Contact us</div>
               <div><a href="tel:075782566051">0757-82566051 Ms. He</a> </div>
              <div><a href="tel:075782562331">0757-82562331 Ms. Liang</a></div>
            </div> -->
          </div>
        </div>
    </div>


    <Pane class="mt30" :title="$t('sidebar.d_news')">
      <div class="flexbox screen2">
        <div class="col">
          <router-link to="/news" class="video-box">
            <!-- <video controls="controls" src="https://www.uniceramicsexpo.com/static/2022.mp4"></video> -->
            <img src="https://www.uniceramicsexpo.com/img/20230710.jpg?temp=0908" />
          </router-link>
        </div>

        <!-- <div class="col">
          <router-link to="/news" class="video-box">
            <img src="https://www.uniceramicsexpo.com/img/20230707.jpg" />
          </router-link>
        </div> -->
      </div>

      <!-- <router-link to="/dynamic/news"><Btn :title="$t('btn.more')"></Btn></router-link> -->

    </Pane>
    

    <Pane class="mt20" :title="$t('index.t5')">
      <ul class="flexbox screen4">
        <li v-for="(item,index) in museum" :key="index">
          <!-- <img src="@/assets/index/s301.jpg" alt=""> -->
          <div class="img-box">
            <img :src="item.picture" alt="">
            <div class="mask">
              <a :href="item.url" class="preview-detail mt20" target="_bland"><i class="el-icon-d-arrow-right"></i></a>
            </div>
            <a :href="item.url" class="mobile" target="_bland"></a>
          </div>
          <a :href="item.url" target="_bland">{{item.title}}</a>
        </li>
      </ul>
    </Pane>


    <!-- <div class="screen5">
      <div class="flexbox">
        <div>
          <h3 class="fs20 mb30 hack" style="margin-top:1vw;">Dear exhibitors, buyers, visitors, guests, support organizations and partners at home and abroad,</h3>
           <P class="fs16 mb30">With the support and encouragement of all parties, Uniceramics Expo 2021 has concluded successfully. The Organizing Committee has decided that the 2022 edition of Uniceramics Expo will be held in Tanzhou International Convention and Exhibition Center from 20 to 24 July 2022, combing both the ceramics products expo and the ceramics technology expo under the same roof. </P>
          <P class="fs16 mb20">Exhibition sectors for the ceramics products expo: ceramic floor and wall tiles, slab, exterior wall tiles, porcelain stoneware, foamed ceramics, featured ceramic products, sanitary installations, home furnishings, etc.</P>
          <P class="fs16 mb20">Exhibition sectors for the ceramics technology expo: ceramics machinery and equipment, ceramics smart factory, deep processing equipment for slab, ceramics ink, glaze and pigment, raw materials, ceramics designs, etc.</P>
          <P class="fs16 mb20">Uniceramics Expo will continue to adhere to the operation philosophy of “Operate Professionally, Provide Accurate Service, Broaden Channels and Buy and Sell Globally”, link more high-quality resources and business opportunities and create more value!</P>
          <P class="fs16">Hotline for booth enquiry:</P>
          <P class="fs16">Eva +86 185 6602 1320</P>
          <P class="fs16 mb40">eva_chan@uniceramics.com.cn</P>
          <router-link to="/news"><Btn :title="$t('btn.more')"></Btn></router-link>
        </div>
        <div>
          <img src="@/assets/index/s501.jpg" alt="" style="object-fit: cover;">
        </div>
      </div>
    </div> -->

    <!-- <div class="screen5">
      <div class="flexbox">
        <div>
          <h3 class="fs20 mb30 hack" style="margin-top:1vw;">Dear exhibitors, buyers, visitors, partners and medias at home and abroad,</h3>
          <P class="fs16 mb30">Happy New Year! After a joyful Spring Festival, we have renewed our efforts to 2023!</P>
          <P class="fs16 mb20">2023 abounds in promise and opportunities. After communicating with different parties, and comprehensively considering the convenience of exhibitors and buyers at home and abroad, we hereby officially announce the dates as following: Uniceramics Products Expo 2023, from 15th to 19th April (same time as the Canton Fair phase one); Uniceramics Technology Expo 2023, from 30th May to 2nd June, both in Tanzhou International Convention and Exhibition Center Foshan.</P>
          <P class="fs16 mb20">Buyer invitation and organization are well prepared for both expos, here are some highlights: </P>
          <P class="fs16 mb20">【Uniceramics Products Expo】</P>
          <P class="fs16 mb20">1, Buyers including: Distributors, decoration companies, designers, real estate developers, custom-made home/furniture companies, stone dealers, and slab fabricator. Various forums, procurement matchmaking meetings, ecological chain cooperation conferences, and distributors’ conferences will be held. </P>
          <P class="fs16 mb20">2, Service: on the basis of original visitor service and vehicle connection, a dedicated Canton Fair Shuttle service will be added (route: Canton Fair Complex - Tanzhou Exhibition Center - Huaxia Ceramics City). </P>
          <P class="fs16 mb20">3, Promotion: deliver exhibition information to buyers through multi-dimensional channels.</P>
          <P class="fs16 mb20">【Uniceramics Technology Expo】 </P>
          <P class="fs16 mb20">1, Buyers including: Factory leaders, factory directors, technicians, purchasing managers, industry technical experts in major ceramic production areas at home and abroad.Overseas buyers: delegations from Vietnam, India, Iran, Bangladesh, Turkey, Indonesia, Malaysia and other countries.
Domestic buyers: factories delegations for on-site technical exchanges and procurement (Free shuttle service included, registration contact: Mr. Li Zhiwen, Mobile: 135 8059 5381).</P>
          <P class="fs16 mb20">2, Conferences and roadshows for new technology jointly held with Italian and Spanish enterprises.</P>
          <P class="fs16 mb20">3, Procurement, recruitment matchmakings between Chinese-funded overseas ceramics enterprises and exhibitors.</P>
          <P class="fs16 mb20">See you in Foshan in the best season!</P>
          <P class="fs16 mb20" style="text-align:right;">See you in Foshan in the best season!</P>
          <P class="fs16 mb20" style="text-align:right;">6th February 2023</P>

          <P class="fs16 mb20"></P>
          <P class="fs16 mb20">Thank you for your continuous support to Uniceramics Expo!</P>
          <P class="fs16 mb20">Customer Service: Eva (Mobile: 185 6602 1320, Email: eva_chan@uniceramics.com.cn)</P>
          <router-link to="/news"><Btn :title="$t('btn.more')"></Btn></router-link>
        </div>
        <div>
          <img src="@/assets/index/s501.jpg" alt="" style="object-fit: cover;">
        </div>
      </div>
    </div> -->

    <div class="screen5">
        <div class="wrap">
          <video class="edui-upload-video  vjs-default-skin  video-js" controls="" preload="meta" width="690" height="388" src="https://admin.uniceramics.com.cn/uploads/editor/4v321Poawwif9m20hZEOtEyX8N8YbduwsiXYzjC2.mp4">
              <source src="https://admin.uniceramics.com.cn/uploads/editor/4v321Poawwif9m20hZEOtEyX8N8YbduwsiXYzjC2.mp4" type="video/mp4">
          </video>
      </div>
    </div>

   
    <div class="screen6 mb40">
      <Title :title="$t('index.zcdw')" color="black"></Title>
      <ul>
        <li v-for="(item,index) in support" :key="index">
          <a :href="item.url" target="_bland">
            <img :src="item.picture" :alt="item.title">
          </a>
        </li>
      </ul>
      <!-- <Roll :list="support"  :speed="30000"  sname="supportSwiper"></Roll> -->
    </div>

    <div class="screen6 mb40">
      <Title :title="$t('index.blogroll')" color="black"></Title>
      <Roll :list="flinks" :speed="124430" sname="flinksSwiper"></Roll>
      <!-- <ul>
        <li v-for="(item,index) in flinks" :key="index">
          <a :href="item.url" target="_bland">
            <img :src="item.picture" :alt="item.title">
            <span>{{item.title}}</span>
          </a>
        </li>
      </ul> -->
    </div>

  </Page>
</template>

<script>
import Page  from '@/components/page.vue'
import Btn from '@/components/Button/Btn.vue'
import Title from '@/components/Title/title.vue'
import Slide from './components/slide.vue'
import Pane from './components/pane.vue'
import Roll from './components/Roll.vue'
import axios from 'axios';


const slist3 = [{thumb:require('@/assets/index/s301.jpg'),title:'岩板+定制馆'},
{thumb:require('@/assets/index/s302.jpg'),title:'岩板+定制馆'},
{thumb:require('@/assets/index/s303.jpg'),title:'岩板+定制馆'}
]

export default {
  name: 'index',
  components:{Page,Title,Btn,Slide,Pane,Roll},
  data(){
    return {
      slide_bg:'',
      slist3,
      covidTips:false,
      codeIsShow:false,
      bmcodesrc:require("@/assets/bmcode.gif"),
      shareUrl:"https://reg.uniceramics.com.cn/"
    }
  },
  created(){
    this.$store.dispatch('index/getBanner');
    this.$store.dispatch('index/getNews1');
    this.$store.dispatch('index/getNews2');
    this.$store.dispatch('index/getActivity');
    this.$store.dispatch('index/getFlinks');
    this.$store.dispatch('index/getSupport');
    this.$store.dispatch('index/getMuseum');
    // console.log('index created');
  },
  mounted(){
    const source = this.$route.query.source;
    let url = "https://admin.uniceramics.com.cn/api/census"
    if(typeof source!=='undefined'){
      url+="/"+source
    }
    axios.get(url);
    //109
    if(source==='360'){
      // this.bmcodesrc = "http://www.uniceramics.com.cn/2021/bm2021-360.png";
      this.shareUrl="https://reg.uniceramics.com.cn/login?source=109";
    }
    //3
    if(source==='baidu'){
      // this.bmcodesrc = "http://www.uniceramics.com.cn/2021/bm2021-baidu.png";
      this.shareUrl="https://reg.uniceramics.com.cn/login?source=3";

    }
    //110
    if(source==='sougou'){
      // this.bmcodesrc = "http://www.uniceramics.com.cn/2021/bm2021-sougou.png";
      this.shareUrl="https://reg.uniceramics.com.cn/login?source=110";
    }
  },
  activated(){
    console.log('index activated');
  },
  computed:{
    banner(){return this.$store.state.index.banner},
    news1(){return this.$store.state.index.news1},
    news2(){return this.$store.state.index.news2},
    activity(){return this.$store.state.index.activity},
    flinks(){return this.$store.state.index.flinks},
    support(){return this.$store.state.index.support},
    lang(){return this.$store.state.index.lang},
    museum(){return this.$store.state.index.museum}
  },
  watch:{
    banner:function(val){
      this.slide_bg = val[0].picture;
      console.log("slide watch");
    }
  },
  methods:{
    opencode(){
      this.codeIsShow = true;
    },
    close(e){
      if(e.target.tagName!='IMG'){
        this.codeIsShow = false;
      }
    }
  }
}
</script>

<style scoped>

/* .popup-code{visibility: hidden; position: fixed; z-index:9999; top:0; bottom:0; left:12.5%; right:0; background:rgba(0,0,0,0); transition-duration: 300ms; display:flex;}
.popup-code.show{visibility: visible; background:rgba(0,0,0,.7);}
.popup-code .close{position: absolute; right: 1.5vw; top: 1.2vw;font-size: 2vw;color: #fff; cursor: pointer;-webkit-transition: all .5s;transition: all .5s; z-index: 10;}
.popup-code .close:hover{transform: rotate(90deg);}
.popup-code .code{text-align:center; width:20vw; height:20vw; margin:auto; opacity:0; transition-duration:300ms;}
.popup-code .code::after{content:'扫描二维码报名';color:#fff; font-size:1.5vw; display:inline-block; margin-top:0.5vw;}
.popup-code .code img{width:20vw; display:block; }
.popup-code.show .code{opacity:1;} */
.popup-code{visibility: hidden; position: fixed; z-index:9999; top:0; bottom:0; left:12.5%; right:0; background:rgba(0,0,0,0); transition-duration: 300ms; display:flex;}
.popup-code.show{visibility: visible; background:rgba(0,0,0,.7);}
.popup-code .close{position: absolute; right: 1.5vw; top: 1.2vw;font-size: 2vw;color: #fff; cursor: pointer;-webkit-transition: all .5s;transition: all .5s; z-index: 10;}
.popup-code .close:hover{transform: rotate(90deg);}
.popup-code .code{text-align:center; width:32vw;  margin:auto; opacity:0; transition-duration:300ms;}
.popup-code .code img{width:32vw; display:block; }
.popup-code.show .code{opacity:1;}


.slidebox{height:43.25vw; position: relative; overflow:hidden;}
.slidebox>.wrap{display:flex; justify-content: center; align-items: center; position: absolute; top:0;bottom:0; left:0; right:0; background:rgba(0,0,0,0.5); color:#fff;}
.slidebox>.wrap h2{font-size: 4.29166667vw; color: #fff; font-weight: 500; margin-bottom: 1.50905vw; text-align: center;}
.slidebox>.wrap h4{font-size:2.31591vw; font-weight: 500; text-align: center; margin-bottom:0.5211vw;}
.slidebox>.wrap h4:nth-of-type(2){font-size:2.31591vw; font-weight: 500; text-align: center; margin-bottom:2.5211vw;}

.slidebox>.wrap .btn-box{ display:flex; justify-content: center;}
.slidebox>.wrap .btn-box .main-button{margin:0 0.5vw; width:16vw; height:3.5vw; font-size:0.6vw;}

.flexbox{display: flex;}
.screen2{color:#fff; justify-content: space-between; padding:1.2vw 1.4vw;}
.screen2 .col .imgbtn{width:32.526312vw; height:15.7895vw; background:url(../../assets/index/btnbg01.jpg) no-repeat; background-size:100% 100%;}
.screen2 .col .imgbtn{box-sizing: border-box;/* padding-left:15.5895vw; padding-top:4.47368vw;*/}
.screen2 .col .imgbtn h3{font-size:1.36vw; margin-bottom:3.1vw;}
.screen2 .col .article-list li{width:32.526312vw; height:3.42vw; line-height:3.42vw; font-size:0.9vw; border-bottom:1px solid #eee;}
.screen2 .col .article-list li>a{display:block; color:#000; transition-duration: 300ms;}
.screen2 .col .article-list li>a:hover{display:block; color:#c72a27;}
.screen2 .col:nth-of-type(2) .article-list li>a:hover{color:#1a3eb3;}
.screen2 .col:nth-of-type(2) .imgbtn{background:url(../../assets/index/btnbg02.jpg) no-repeat; background-size:100% 100%;}

.screen2 .col .video-box>video{width:32.526312vw; height:18.5vw;}
.screen2 .col .video-box>img{width:66.5vw; height:18.7vw; object-fit: cover;}


.screen3 .title-box{margin:3vw 0 1.5vw 6.23428859vw}
.screen3 ul{display: flex; flex-wrap: wrap; justify-content: space-between;}
.screen3 li{display:block; width:28.42vw; height:16.21vw; position: relative; margin-bottom:0.9vw;}
.screen3 li img{width:100%; height:100%;}
.screen3 li .mask,
.screen4 li .mask
{position:absolute; width: 100%; height: 100%;top:0; left:0;opacity: 0;background: #fff; transition-duration: 300ms;
  display:flex; flex-direction: column; align-items: center;justify-content: center;}
.screen3 li .mask .preview-detail,
.screen4 li .mask .preview-detail
{width: 2.29166667vw;height: 2.29166667vw;background: #d70e19;border-radius: 50%;display: flex;justify-content: center;align-items: center;font-size: 1.04166667vw;color: #fff;}
.screen3 li:hover .mask,
.screen4 li:hover .mask
{opacity: .95;}

.screen3 li .mask div{transition-duration: 400ms; opacity:0; transform: translateY(-10px);}
.screen3 li .mask .preview-detail{transition-duration: 400ms; opacity:0; transform: translateY(10px);}
.screen3 li:hover .mask div{opacity:1; transform: translateY(0);}
.screen3 li:hover .mask .preview-detail{opacity:1; transform: translateY(0);}


.screen4{color:#fff; justify-content: space-between; padding:1.2vw 1.4vw;}
.screen4 li{display:block; position: relative; margin-bottom:0.9vw;}
.screen4 li .img-box{width:21.58vw; height:21.58vw; position: relative;}
.screen4 li .img-box img{width:100%; height:100%;}
.screen4 li .img-box .mask .preview-detail{width: 2.5vw;height: 2.5vw; transform: scale(.6); opacity:0; transition-duration:400ms;}
.screen4 li:hover .img-box .mask .preview-detail{transform: scale(1); opacity:1;}
.screen4 li>a{display:block; color:#333; margin:0.5vw 0; font-size:0.947368vw;}


.screen5 .title-box{margin:3vw 0 1.5vw 6.23428859vw}
.screen5 .flexbox{justify-content: space-between; padding:0 6.23428859vw;}
.screen5 .flexbox div:nth-of-type(1){width:37.9vw;}
.screen5 .flexbox div:nth-of-type(1) h3{margin-top:5vw;}
.screen5 .flexbox div:nth-of-type(1) p{line-height:1.5vw;}

.screen5 .flexbox div:nth-of-type(2){width:29vw; height:20vw; margin:5vw 0 0 0;}
.screen5 .flexbox div:nth-of-type(2) img{width:100%; height:100%;}
.screen5 .hack{line-height:1.5vw;}

.screen5 .wrap{width: 68.273684vw; margin:0 auto;}
.screen5 video{width: 68.273684vw; height:38vw; margin:0 auto;}

.screen6 .title-box{margin:3vw 0 1.5vw 6.23428859vw}
.screen6 ul{display:flex; flex-wrap:wrap; margin:1vw 0 1.5vw 6.23428859vw}
.screen6 ul li{margin-right:1vw; margin-bottom:0.6vw;}
.screen6 ul li a{display:block;}
.screen6 ul li a img{height:2.6vw;}
.screen6 ul li a span{display:block; text-align: center; font-size:1vw;}


.contact-box{font-size:1.4vw; text-align: center; margin-top:1vw;}
.contact-box div:nth-of-type(1){margin:2vw 0 0.5vw 0;}
.contact-box div:nth-of-type(2),.contact-box div:nth-of-type(3){ line-height:2.2vw;font-weight: bold;}



@media (min-width: 992px){}
@media (max-width: 991px){
/* .popup-code{left:0;top:55px;}
.popup-code .close{font-size:7vw;}
.popup-code .code{width:60vw; height:60vw;}
.popup-code .code img{width:60vw;}
.popup-code .code::after{content:'长按二维码进入报名';color:#fff; font-size:4vw; display:inline-block; margin-top:1vw;} */
.popup-code{left:0;top:55px;}
.popup-code .close{font-size:7vw;}
.popup-code .code{width:85vw;}
.popup-code .code img{width:85vw;}


.slidebox{height:50vw;}
.slidebox>.wrap h2{font-size: 4.8vw;  margin-bottom: 2.1vw;}
.slidebox>.wrap h4{font-size:2.9vw; margin-bottom:1vw;}
.slidebox>.wrap h4:nth-of-type(2){font-size:2.9vw; margin-bottom:4vw;}
.slidebox>.wrap .btn-box .main-button{margin:0 3vw; width:35vw; height:9vw;}


.screen2{padding:2.5vw 2.42vw 1vw 2.42vw; flex-wrap: wrap;}
.screen2 .col{margin-bottom:0vw;}
.screen2 .col .imgbtn{width:90vw; height:44vw; /*padding-left:43vw; padding-top:12vw;*/}
.screen2 .col .imgbtn h3{font-size:4vw; margin-bottom:7.5vw;}
.screen2 .col .article-list li{width:90vw; height:10vw; line-height:10vw; font-size:3.2vw; border-bottom:1px solid #eee;}
.screen2 .col .video-box>video{width:90vw; height:50.5vw;}
.screen2 .col .video-box>img{width:90vw; height:26.3vw; object-fit: cover;}

.screen3 .title-box{margin:2vw 0 2.5vw 6.23428859vw}
.screen3 ul{justify-content: space-around;}
.screen3 li{width:48vw; height:24.3vw; margin-bottom:1.6vw;}
.screen3 li .mobile,.screen4 li .mobile{position:absolute; width: 100%; height: 100%;top:0; left:0;opacity: 0;}
.screen3 li .mask,.screen4 li .mask{display:none;}

.screen4 li .img-box{width:29.5vw; height:29.5vw;}
.screen4 li>a{margin:1vw 0; font-size:3.2vw;}

.screen5 .flexbox div:nth-of-type(1){width:92vw;}
.screen5 .flexbox div:nth-of-type(1) p{line-height:4.5vw;}
.screen5 .flexbox div:nth-of-type(2){display: none;}
.screen5 .flexbox .mb100{margin-bottom:8vw;}
.screen5 .fs20{font-size:3.8vw; line-height:3.8vw;}
.screen5 .fs16{font-size:3.2vw; line-height:3.2vw;}
.screen5 .hack{line-height:4vw;}


.screen6 .title-box{margin:8vw 0 4vw 6.23428859vw}
.screen6 ul{display:flex; flex-wrap:wrap; justify-content: space-around; margin:1vw 0 1.5vw 6.23428859vw; flex-wrap: wrap;}
.screen6 ul li{margin-right:2vw; margin-bottom:2vw;}
.screen6 ul li a{display:block;}
.screen6 ul li a img{height:7vw;}
.screen6 ul li a span{display:block; text-align: center; font-size:3vw;}

.contact-box{font-size:3vw; text-align: center; margin-top:1vw;}
.contact-box div:nth-of-type(1){margin:3vw 0 0.5vw 0;}
.contact-box div:nth-of-type(2),.contact-box div:nth-of-type(3){ line-height:4.5vw;font-weight: bold;}
}
</style>

<style type="text/css">
  .slidebox>.wrap .btn-box .main-button .text span{font-size:1.4vw; font-weight: bold;}
  .slidebox>.wrap .btn-box .main-button .text i{font-size:1.5vw;}
@media (max-width: 991px){
  .slidebox>.wrap .btn-box .main-button .text span{font-size:3.2vw;}
  .slidebox>.wrap .btn-box .main-button .text i{font-size:1.8vw;}
}
</style>
